export const FORM_STATES = {
	DATA: 'DATA',
	CONFIRMATION: 'CONFIRMATION',
	LOADING: 'LOADING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR'
};

export const INVOICE_FORMAT_OPTIONS = [
	{
		key: 'E_INVOICE',
		value: 'e-számla'
	},
	{
		key: 'PDF',
		value: 'PDF'
	}
];
